module.exports = __webpack_public_path__ + "static/assets/8fb1ae10751d3d5419a11b782ba369fe.png";